import { render, staticRenderFns } from "./Pal.vue?vue&type=template&id=4f6acfbf&scoped=true&"
import script from "./Pal.vue?vue&type=script&lang=js&"
export * from "./Pal.vue?vue&type=script&lang=js&"
import style0 from "./Pal.vue?vue&type=style&index=0&id=4f6acfbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6acfbf",
  null
  
)

export default component.exports